import GetStrong from '../../pages/get-strong/GetStrong'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.GET_STRONG, component: GetStrong },
])
